export enum ErpSources {
	SYSCO = 'sysco',
	DEFAULT = 'default',
}
